import {api} from '../../contexts/AuthContext';
import {FeedbackRequest} from '../../types';

// Feedback API
export const feedbackApi = {
    submit: async (feedback: FeedbackRequest): Promise<{ success: boolean; message: string }> => {
        const response = await api.post('/api/feedback', feedback);
        return response.data;
    },
};
